import {
  READ_EVENT_RESOURCES_LIST,
  READ_EVENT_RESOURCES_LIST_SUCCEEDED,
  READ_EVENT_RESOURCES_LIST_FAILED,
  RESET_EVENT_RESOURCES_LIST,
  ADD_EVENT_RESOURCE,
  ADD_EVENT_RESOURCE_SUCCEEDED,
  ADD_EVENT_RESOURCE_FAILED,
  DELETE_EVENT_RESOURCE,
  DELETE_EVENT_RESOURCE_SUCCEEDED,
  DELETE_EVENT_RESOURCE_FAILED,
  READ_EVENT_AVAILABLE_RESOURCES_LIST,
  READ_EVENT_AVAILABLE_RESOURCES_LIST_SUCCEEDED,
  READ_EVENT_AVAILABLE_RESOURCES_LIST_FAILED,
} from "./types"

export const readEventResourcesList = config => {
  return { type: READ_EVENT_RESOURCES_LIST, config }
}

export const readEventResourcesListSuccess = (action, response) => {
  return { type: READ_EVENT_RESOURCES_LIST_SUCCEEDED, action, response }
}

export const readEventResourcesListError = (action, error) => {
  return { type: READ_EVENT_RESOURCES_LIST_FAILED, action, error }
}

export const resetEventResourcesList = () => {
  return { type: RESET_EVENT_RESOURCES_LIST }
}

export const readEventAvailableResourcesList = config => {
  return { type: READ_EVENT_AVAILABLE_RESOURCES_LIST, config }
}

export const readEventAvailableResourcesListSuccess = (action, response) => {
  return {
    type: READ_EVENT_AVAILABLE_RESOURCES_LIST_SUCCEEDED,
    action,
    response,
  }
}

export const readEventAvailableResourcesListError = (action, error) => {
  return { type: READ_EVENT_AVAILABLE_RESOURCES_LIST_FAILED, action, error }
}

export const addEventResource = config => {
  return { type: ADD_EVENT_RESOURCE, config }
}

export const addEventResourceSuccess = (action, response) => {
  return { type: ADD_EVENT_RESOURCE_SUCCEEDED, action, response }
}

export const addEventResourceError = (action, error) => {
  return { type: ADD_EVENT_RESOURCE_FAILED, action, error }
}

export const deleteEventResource = config => {
  return { type: DELETE_EVENT_RESOURCE, config }
}

export const deleteEventResourceSuccess = (action, response) => {
  return { type: DELETE_EVENT_RESOURCE_SUCCEEDED, action, response }
}

export const deleteEventResourceError = (action, error) => {
  return { type: DELETE_EVENT_RESOURCE_FAILED, action, error }
}
